export const RESET_PASSWORD_SAGAS = 'RESETPASSWORDSAGAS';
export const RESET_PASSWORD = 'RESETPASSWORD';
export const RESET_PASSWORD_FORGOT_SAGAS = 'RESETPASSWORDFORGOTSAGAS';
